import { Component } from '@angular/core';
import { PublicationType } from '@fi-shared/types/pubication-type';
import { ChecklistTimeSettings } from '../../types/time-settings';
import { ItemsListRowItemDateTimeComponent } from '@fi-app/components/items-list/list-row/list-row-item/date-time/date-time.component';

@Component({
    selector: 'checklist-list-item-due-date-time',
    templateUrl: './item-due-date-time.component.html',
    standalone: false,
})
export class ChecklistListItemDueDateTimeComponent extends ItemsListRowItemDateTimeComponent {
    isUnlimited() {
        return (
            this.data.TimeSetting === ChecklistTimeSettings.OneTime &&
            this.data.PublicationSetting &&
            this.data.PublicationSetting.PublicationType === PublicationType.Continous
        );
    }
}
